/* eslint-disable no-nested-ternary */
import ArrowButton from './button-arrow';

const Button = ({
  children, submit = false, inline = false, hidden = false, ...props
}) => (
  <div style={{display: (hidden ? 'none' : (inline ? 'inline-block' : 'block'))}}>
    <ArrowButton
      arrow={false}
      submit={submit}
      {...props}
    >
      {children}
    </ArrowButton>
  </div>
);

export default Button;

